<template>
    <div class="sidenav-content-container">
        <div class="sidenav-content-frame">
            <!--
              계정 권한(privileges)이 주는 메뉴. 모바일도 PC 와 같은 목록을 쓴다.

              예전에는 여기에 v-if="!isMobile || isZeiss" 가 붙어 있어 폰에서는 이 목록을 통째로
              건너뛰고, 아래 하드코딩된 전자계약·안내 두 개만 보여 줬다. 그래서 폰에서는 권한이 있어도
              다른 화면으로 갈 수 없었다. 모바일 전용 메뉴를 따로 두지 않기로 하고 그 조건을 걷어냈다.
            -->
            <div
                class="sidenav-category-container"
                v-for="(category, index) in enhancedMenu"
                :key="index"
            >
                <div
                    class="sidenav-category-title"
                    v-if="category.name"
                >
                    <span>{{ category.name }}</span>
                </div>
                <div class="sidenav-category-items"
                    v-for="(menu, menuIndex) in category.menu"
                    :key="menuIndex"
                >
                    <sidenav-item
                        :url="getMenuUrl(menu)"
                        :class="getRoute() === getMenuUrl(menu) ? 'active' : ''"
                        :navText="menu.menuName"
                        :outerPath="menu.isNewWindow === 'Y' ? menu.link : null"
                        @mouseover="menu.isHover = true"
                        @mouseleave="menu.isHover = false"
                    >
                        <template v-slot:icon>
                            <img
                            :src="withIconVersion(getRoute() === getMenuUrl(menu) || menu.isHover ? menu.iconActiveUrl : menu.iconDefaultUrl)"
                            />
                        </template>
                    </sidenav-item>
                </div>
            </div>
            <div class="sidenav-category-container" v-if="hasStudioAccess && !hideStudioLink">
                <div class="sidenav-category-items">
                    <div class="sidenav-item-container studio-nav-item" @click="goToStudio">
                        <div class="sidenav-item-icon" style="color: #454c53">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                                <polyline points="15 3 21 3 21 9"/>
                                <line x1="10" y1="14" x2="21" y2="3"/>
                            </svg>
                        </div>
                        <div class="sidenav-item-text">스튜디오로 이동</div>
                    </div>
                </div>
            </div>
            <!--
              브라이트몰 주문 관리는 여기 있었으나 MobileTabBar 로 옮겼다.

              이 사이드바는 폰에서 열 수 없게 됐고(햄버거 제거), PC 에서는 원래도
              브라이트몰이 메뉴에 없었다. 그래서 여기 두면 아무 데서도 보이지 않는다.

              노출 조건(isDentium — 토큰의 회사 ID)은 탭 바로 그대로 옮겨서
              보이는 사람이 달라지지 않는다.
            -->
        </div>
    </div>
</template>
<script>
import { getAccessToken, getProfile, isSupportTab } from '@/utils/tokenStore';
import SidenavItem from './SidenavItem.vue';
import {RouterEnum} from "@/enums/router.enums";
import {isBlockedOnMobile} from "@/utils/mobileAccess";
import {withIconVersion} from "@/utils/menuIcon";
import { blockedInSupportTab } from '@/utils/supportSession';
import { openStudio } from '@/services/handoff.service';
import { alreadyNotified } from '@/utils/mfa';
import { legacyMenus, menuItemAllowed, shouldUseNewRule } from '@/utils/permUi';
import { jwtDecoder } from '@/utils/utils';
import { masterCheckUsername } from '@/utils/supportMaster';

export default {
    name: 'SidenavList',
    computed: {
        Path() {
            return {
            Dashboard: `${RouterEnum.Dashboard.path}`,
            ItemList: `${RouterEnum.ItemManagement.path}/${RouterEnum.ItemManagement.ItemList.path}`,
            ProductList: `${RouterEnum.ProductManagement.path}`,
            CertificateList: `${RouterEnum.Certificate.path}/${RouterEnum.Certificate.CertificateList.path}`,
            HospitalList: `${RouterEnum.HospitalManagement.path}/${RouterEnum.HospitalManagement.HospitalList.path}`,
            AddHospital: `${RouterEnum.HospitalManagement.path}/${RouterEnum.HospitalManagement.AddHospital.path}`,
            // HospitalAccountList: `${RouterEnum.HospitalManagement.path}/${RouterEnum.HospitalManagement.HospitalAccountManagement.path}`,
            ModifyHospital: `${RouterEnum.HospitalManagement.path}/${RouterEnum.HospitalManagement.ModifyHospital.path}`,
            BrightmallOrders: `${RouterEnum.BrightmallManagement.path}/${RouterEnum.BrightmallManagement.Orders.path}`,
            EventList: `${RouterEnum.EventManagement.path}/${RouterEnum.EventManagement.EventList.path}`,
            AddEvent: `${RouterEnum.EventManagement.path}/${RouterEnum.EventManagement.AddEvent.path}`,
            EventDashboard: `${RouterEnum.EventManagement.path}/${RouterEnum.EventManagement.EventDashboard.path}`,
            EventListV2: `${RouterEnum.EventManagementV2.path}/${RouterEnum.EventManagementV2.EventList.path}`,
            EventStatistics: `${RouterEnum.EventManagementV2.path}/${RouterEnum.EventManagementV2.EventStatistics.path}`,
            DailyStatistics: `${RouterEnum.EventManagementV2.path}/${RouterEnum.EventManagementV2.DailyStatistics.path}`,
            GoalManagement: `${RouterEnum.ContractManagement.path}/${RouterEnum.ContractManagement.Goal.path}`,
            ManufacturerAccountsList: `${RouterEnum.ManufacturerAccounts.path}/${RouterEnum.ManufacturerAccounts.ManufacturerAccountsList.path}`,
            ApiKeyList: `${RouterEnum.ApiKeyManagement.path}`,
            CompanyInfo: `${RouterEnum.CompanyManagement.path}`,
            NoticeList: `${RouterEnum.NoticeManagement.path}/${RouterEnum.NoticeManagement.NoticeList.path}`,
            }
        },
        pointImplantNotVisible() {
            const userId = this.$store.state.userInfo.userId
            return userId !== 'point';
        },
        isZeiss() {
            // 지원 탭이면 그 회사 최상위 관리자 아이디로(utils/supportMaster)
            const userId = masterCheckUsername(this.$store.state.userInfo.userId, this.$store.state.privileges)
            return userId.includes('zeiss');
        },
        enhancedMenu() {
            const baseMenu = Array.isArray(this.menu) ? this.menu : [];
            const promotionPath = RouterEnum.Promotions.path;
            // can()(계약 PERMISSIONS 7): permMode 가 이 앱에 enforce 인 날만 새 규칙으로 숨김. log·off·모름이면 지금 메뉴 그대로.
            // 라우터가 같은 menuItemAllowed 로 주소 이동을 막음(permUi.routeDenial)
            const intro = this.$store.state.introspect;
            const { table } = legacyMenus(baseMenu);
            const permOk = (item) => menuItemAllowed(item, { perms: intro?.profile?.perms, modes: intro?.modes }, table);
            return baseMenu
                .map((category) => ({
                    ...category,
                    menu: (category?.menu || []).filter((item) => (
                        item?.link !== promotionPath &&
                        item?.menuName !== '프로모션 운영' &&
                        // 스튜디오 접근 권한 메뉴(code=STUDIO_ACCESS, link='/studio')는 실제 라우트가
                        // 아닌 권한 식별용 sentinel이라 LNB에 렌더하면 manufacturer 도메인 하위 /studio로
                        // 이동하는 깨진 링크가 됨. 스튜디오 이동은 전용 푸터 버튼으로만 처리한다.
                        item?.code !== 'STUDIO_ACCESS' &&
                        item?.link !== '/studio' &&
                        // 폰에서 막은 갈래는 메뉴에서도 뺀다.
                        // 라우터 가드와 같은 목록(utils/mobileAccess.js)을 보므로
                        // 메뉴에 보이는데 누르면 튕기는 일이 생기지 않는다.
                        !(this.isMobile && !this.isZeiss && isBlockedOnMobile(item?.link)) &&
                        permOk(item)
                    )),
                }))
                .filter((category) => category.menu.length > 0);
        },
        // STUDIO_ACCESS 권한(privilege)이 부여된 계정에만 스튜디오 버튼 노출 — 제조사 권한 기반 메뉴 모델 준수.
        // sentinel 메뉴(link='/studio')는 enhancedMenu에서 렌더 제외하되, 그 부여 여부를 버튼 게이트로 재사용한다.
        // 새 권한(enforce — 권한을 고른 직원) 날엔 inapi 가 새 권한의 studio 코드로 다시 계산한 hasStudioAccess
        // (introspect profile — /auth/profile 과 같은 값, studio 진입도 이 값으로 막음)를 따름. 옛 STUDIO_ACCESS 메뉴는 보지 않음
        hasStudioAccess() {
            const intro = this.$store.state.introspect;
            if (shouldUseNewRule(intro?.modes, intro?.profile?.perms)) return intro.profile.hasStudioAccess === true;
            const cats = Array.isArray(this.menu) ? this.menu : [];
            return cats.some((cat) => (cat?.menu || []).some(
                (item) => item?.code === 'STUDIO_ACCESS' || item?.link === '/studio',
            ));
        },
    },
    props: {
        menu: {
            type: Array,
        }
    },
    data() {
        return {
            // navWidth / navWidthOri 는 지운 handleDeviceChange 만 쓰던 값이라 함께 지웠다.
            // isDentium 은 브라이트몰 메뉴 전용이었는데 그 메뉴가 MobileTabBar 로 옮겨가
            // 여기서는 쓰이지 않게 됐다. 판정 로직(checkIsDentium)도 탭 바로 옮겼다.
            isDentiumMember: true,
            // 앱 사이 이동 링크 — 지원 탭도 보임(D1 11-01, 막음 목록에서 appLinks 뺌)
            hideStudioLink: blockedInSupportTab('appLinks', isSupportTab()),
            isMobile: false,
            eventStatsHover: false,
        };
    },
    components: {
        SidenavItem,
    },
    // created 에서 matchMedia 로 handleDeviceChange 를 걸어 두었으나,
    // 그 함수가 찾던 선택자가 마크업에 없어 늘 아무 일도 하지 않았다. 함수와 함께 지웠다.
    watch: {
        // 메뉴(privileges)·권한 값(introspect)이 오면 옛 규칙과 can() 을 비교해 다르면 보고만(W6 C7)
        menu: { handler: 'checkPermUi', immediate: true },
        '$store.state.introspect': 'checkPermUi',
    },
    mounted() {
        if(window.innerWidth >= 768){
            this.isMobile = false;
        } else {
            this.isMobile = true;
        }
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        withIconVersion,
        checkPermUi() {
            if (!Array.isArray(this.menu) || !this.menu.length) return;
            if (!this.$store.state.introspect) {
                this.$store.dispatch('loadIntrospect');
                return;
            }
            // 브라이트몰 주문은 DB 메뉴가 아니라 회사 id 로 하단 탭에 붙음(store getVisibleMobileTabs) — 같은 조건으로 비교만
            const brightmall = jwtDecoder(getAccessToken()) === process.env.VUE_APP_DENTIUM_ID;
            this.$store.dispatch('reportPermUiDiff', legacyMenus(this.menu, { brightmall }));
        },
        // 스튜디오로 이동: 1회용 코드(POST /auth/handoff → <studio>/enter#c=…, K-17 — 옛 토큰 쿼리 링크 대체).
        // 지원 탭이면 서버가 같은 사람으로 studio 지원 세션을 새로 엶(D1 11-01)
        async goToStudio() {
            try {
                await openStudio('/');
            } catch (error) {
                if (!alreadyNotified(error)) this.$message.error('스튜디오로 이동하지 못했습니다. 잠시 후 다시 눌러 주세요.');
            }
        },
        handleResize(){
            if(window.innerWidth >= 768){
                this.isMobile = false;
            } else {
                this.isMobile = true;
            }
        },
        /*
         * handleDeviceChange 를 지웠다.
         *
         * `.navbar-vertical.navbar-expand-xs.fixed-start` 를 찾아 그 안에서만 동작하는 함수였는데,
         * 그 클래스는 이 프로젝트 마크업 어디에도 붙지 않는다(SCSS 선택자로만 남아 있다).
         * 늘 null 을 받아 if 안으로 들어간 적이 없다. 폭에 따른 표시 전환은 CSS 미디어 쿼리가 한다.
         */
        getRoute() {
            return this.$route.path;
        },
        getMenuUrl(menu) {
            let defaultEventId;
            if(process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
                defaultEventId = '688c74fa9bad033589258352'; // 개발
            } else if (process.env.NODE_ENV === 'stage') {
                defaultEventId = '6860e05ccca7ad7006779b45'; // 스테이징
            } else {
                defaultEventId = '6864f97c93111a68978dc3f5'; // 운영
            }
            // 이벤트 통계 메뉴인 경우 V3 경로로 리다이렉트
            if (menu.menuName === '이벤트 통계' && getProfile('manufacturerNameManu') == '자이스코리아') {
                console.log(this.Path.EventStatistics + '?eventId=' + defaultEventId);
                return this.Path.EventStatistics + '?eventId=' + defaultEventId;
            }
            else
            // 일자별 통계 메뉴인 경우
            if (menu.menuName === '일자별 통계' || menu.menuName === 'Daily Statistics') {
                return this.Path.DailyStatistics;
            }
            else
            // 이벤트 목록 메뉴인 경우 새로운 V2 경로로 리다이렉트
            if (menu.menuName === '이벤트 목록' || menu.menuName === 'Event List') {
                return this.Path.EventListV2;
            }
            return menu.link;
        },
    },
};
</script>
